/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { useTranslator } from '@jutro/locale';
import styles from './MLSidebarContactSection.module.scss';
import { Tooltip } from '@jutro/components';
import { Grid, GridItem } from '@jutro/layout';
import classNames from 'classnames';

import { Accordion, AccordionCard, Icon } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

const ACCORDION_CARDS = {
    ARSUWSECTION: 'card1',
    CLAIMSSECTION: 'card2',    
    UWSECTION: 'card3',
    COMMISECTION: 'card4',
    METLIFEGASECTION: 'card5'
};

function MLSidebarContactSection(props) {
    const { metlifeGASection, arsUWSection, claimsSection, commiSection, uwSection, openedAccordions } = props;
    const translator = useTranslator();
    const [currentCard, setCurrentCard] = useState(ACCORDION_CARDS.ARSUWSECTION)
    const [activeCards, setActiveCards] = useState([ACCORDION_CARDS.ARSUWSECTION])

    const goToSelectedAccordion = (thisCard) => {
        setCurrentCard(thisCard);
        rePopulateCurrentCards(thisCard);
    };

    const rePopulateCurrentCards = (newCard) => {
        let newActiveCards = [...activeCards];
        if (_.find(newActiveCards, (c) => { return (c == newCard) }) != null) {
            _.remove(newActiveCards, (c) => {
                return c == newCard;
            });
        } else {
            newActiveCards.push(newCard);
        }
        setActiveCards(newActiveCards);
    }

    const isCardActive = (card) => {
        return (_.find(activeCards, (c) => {
            return c == card;
        }) != null)
    }

    const renderHeader = (active, card) => {
        // Accordion
        const getAccordionNumber = (card) => {
            let number = 0;
            switch (card) {
                case ACCORDION_CARDS.ARSUWSECTION:
                    number += 1;
                    break;
                case ACCORDION_CARDS.CLAIMSSECTION:
                    number += 2;
                    break;
                case ACCORDION_CARDS.COMMISECTION:
                    number += 3;
                    break;
                case ACCORDION_CARDS.UWSECTION:
                    number += 4;
                    break;
                case ACCORDION_CARDS.METLIFEGASECTION:
                    number += 5;
                    break;
                default:
                    break;
            }
            return number;
        };

        const getAccordionCardTitle = (card) => {
            switch (card) {
                case ACCORDION_CARDS.ARSUWSECTION:
                    return arsUWSection.header;
                case ACCORDION_CARDS.CLAIMSSECTION:
                    return claimsSection.header;
                case ACCORDION_CARDS.COMMISECTION:
                    return commiSection.header;
                case ACCORDION_CARDS.UWSECTION:
                    return uwSection.header;
                case ACCORDION_CARDS.METLIFEGASECTION:
                    return metlifeGASection.header;
                default:
                    return '';
            }
        };

        const showEditAction = () => {
            return true
        };

        const index = getAccordionNumber();
        return (
            <div className="ml-payment-header">
                <header>
                    <div className="ml-payment-header__main-content">
                        <div className={styles.gwMLSidebarContactSectionAccordion} >
                            {getAccordionCardTitle(`${card}`)}
                        </div>
                        {showEditAction() && (
                            <span onClick={() => goToSelectedAccordion(`${card}`)}>
                                <Icon icon={isCardActive(`${card}`) ? 'mi-keyboard-arrow-up' : 'mi-keyboard-arrow-down'} />
                            </span>
                        )}
                    </div>
                </header>
            </div>
        );
    };

    const emailLink = (email, mlTagManagerLinkClick) => {
        return <Link href={`mailto:${email}`} mlTagManagerLinkClick={mlTagManagerLinkClick}>{email}</Link>;
    };

    return (
        <Accordion
            boldFont
            chevronAlignment="right"
            closeOthers
            defaultOpenedId={currentCard}
            id="Accordion"
            onUpdateAccordionStates={function noRefCheck() { }}
            showFrame={true}
            closeOthers={false}
            textContent="Accordion Content"
            accordionStates={activeCards}
        >
            {arsUWSection && (
                <React.Fragment>
                    <div className={styles.gwMLSidebarContactSectionAdditionalSubHeader}>{arsUWSection.additionalheader}</div>
                    <AccordionCard
                        id="card1"
                        renderHeader={renderHeader}
                        className={styles.gwMLSidebarContactSectionAccordion}
                    >
                        {arsUWSection.subsections.map((subsection, index) => {
                            return (
                                <React.Fragment>
                                    <Grid
                                        columns={['0.1fr', '1fr']}
                                        alignItems="left"
                                        vgap="none"
                                        hgap="small"
                                    >
                                        <GridItem><Icon className={styles.accountIcon} icon={subsection.icon} /></GridItem>
                                        <GridItem className={styles.gwMLSidebarContactSectionSubHeader}>{subsection.subHeaderText}</GridItem>
                                        {subsection.text.map((item, subIndex) => {
                                            return (<React.Fragment>
                                                <GridItem />
                                                <GridItem
                                                    className={index === 1 && subIndex === 0 ? styles.contactPhoneEmail : ''}
                                                >
                                                    {item}
                                                </GridItem>
                                            </React.Fragment>)
                                        })}
                                    </Grid>
                                    <hr className={styles.gwMLSidebarContactSectionHr} />
                                </React.Fragment>

                            )
                        })}

                    </AccordionCard>

                </React.Fragment>
            )}
            {claimsSection && (
                <React.Fragment>
                    <div className={styles.gwMLSidebarContactSectionAdditionalSubHeader}>{claimsSection.additionalheader}</div>
                    <AccordionCard
                        id="card2"
                        renderHeader={renderHeader}
                        className={styles.gwMLSidebarContactSectionAccordion}
                    >
                        {claimsSection.subsections.map((subsection, index) => {
                            return (
                                <React.Fragment>

                                    <Grid
                                        columns={['0.1fr', '1fr']}
                                        alignItems="left"
                                        vgap="none"
                                        hgap="small"
                                    >
                                        <GridItem><Icon className={styles.accountIcon} icon={subsection.icon} /></GridItem>
                                        <GridItem className={styles.gwMLSidebarContactSectionSubHeader}>{subsection.subHeaderText}</GridItem>
                                        {subsection.text.map((item, subIndex) => {
                                            return <React.Fragment><GridItem
                                            />
                                                <GridItem
                                                    className={
                                                        index === 0 ? (
                                                            subIndex === 0 || subIndex === 2 ? "font-weight-bold" : ''
                                                        ) :
                                                            subIndex === 0 ? styles.contactPhoneEmail : ''
                                                    }>
                                                    {index === 3 ? emailLink(item, "Dashboard_claims_email") : item}
                                                </GridItem>
                                            </React.Fragment>
                                        })}
                                    </Grid>
                                    <hr className={styles.gwMLSidebarContactSectionHr} />

                                </React.Fragment>
                            )
                        })}
                    </AccordionCard>

                </React.Fragment>
            )}            
            {uwSection && (
                <AccordionCard
                    id="card3"
                    renderHeader={renderHeader}
                    className={styles.gwMLSidebarContactSectionAccordion}
                >
                    {uwSection.subsections.map((subsection) => {
                        return (
                            <React.Fragment>
                                <Grid
                                    columns={['0.1fr', '1fr']}
                                    alignItems="left"
                                    vgap="none"
                                    hgap="small"
                                >
                                    <GridItem><Icon className={styles.accountIcon} icon={subsection.icon} /></GridItem>
                                    <GridItem className={styles.gwMLSidebarContactSectionSubHeader}>{subsection.subHeaderText}</GridItem>
                                    {subsection.text && subsection.text.map((item) => {
                                        return <React.Fragment><GridItem /><GridItem>{item}</GridItem></React.Fragment>
                                    })}
                                    {subsection.subSubSections && subsection.subSubSections.map((subSubSection) => {
                                        return (
                                            <React.Fragment>
                                                <GridItem />
                                                <GridItem className={styles.gwMLSidebarContactSectionSubSubHeader}>{subSubSection.subSubHeaderText}</GridItem>
                                                {subSubSection.lines && subSubSection.lines.map((item) => {
                                                    return (
                                                        <React.Fragment>
                                                            <GridItem />
                                                            {item.popup && (
                                                                <GridItem>
                                                                    <span title={item.popup.popupheader + "\n" + item.popup.popuptext}>{item.txt}</span>
                                                                </GridItem>
                                                            )}
                                                            {_.isUndefined(item.popup) && (
                                                                <GridItem>
                                                                    {item.txt}
                                                                </GridItem>
                                                            )}
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </React.Fragment>
                                        )
                                    })}
                                </Grid>
                                <hr className={styles.gwMLSidebarContactSectionHr} />
                            </React.Fragment>
                        )
                    })}
                </AccordionCard>
            )}
            {commiSection && (
                <AccordionCard
                    id="card4"
                    renderHeader={renderHeader}
                    className={styles.gwMLSidebarContactSectionAccordion}
                >
                    {commiSection.subsections.map((subsection) => {
                        return (
                            <React.Fragment>
                                <Grid
                                    columns={['0.1fr', '1fr']}
                                    alignItems="left"
                                    vgap="none"
                                    hgap="small"
                                >
                                    <GridItem><Icon className={styles.accountIcon} icon={subsection.icon} /></GridItem>
                                    <GridItem className={styles.gwMLSidebarContactSectionSubHeader}>{subsection.subHeaderText}</GridItem>
                                    {subsection.text.map((item) => {
                                        return <React.Fragment><GridItem /><GridItem>{item}</GridItem></React.Fragment>
                                    })}
                                </Grid>
                                <hr className={styles.gwMLSidebarContactSectionHr} />
                            </React.Fragment>
                        )
                    })}
                </AccordionCard>
            )}
            {metlifeGASection && (
                <React.Fragment>
                    <div className={styles.gwMLSidebarContactSectionAdditionalSubHeader}>{metlifeGASection.additionalheader}</div>
                    <AccordionCard
                        id="card5"
                        renderHeader={renderHeader}
                        className={styles.gwMLSidebarContactSectionAccordion}
                    >
                        {metlifeGASection.subsections.map((subsection, index) => {
                            return (
                                <React.Fragment>
                                    <Grid
                                        columns={['0.1fr', '1fr']}
                                        alignItems="left"
                                        vgap="none"
                                        hgap="small"
                                    >
                                        <GridItem><Icon className={styles.accountIcon} icon={subsection.icon} /></GridItem>
                                        <GridItem className={styles.gwMLSidebarContactSectionSubHeader}>{subsection.subHeaderText}</GridItem>
                                        {subsection.text.map((item, subIndex) => {
                                            return <React.Fragment><GridItem />
                                                <GridItem className={
                                                    index > 0 && subIndex === 0 ? styles.contactPhoneEmail : ''
                                                }>
                                                    {index === 3 ? emailLink(item, "Dashboard_metlifeGA_email") : item}
                                                </GridItem>
                                            </React.Fragment>
                                        })}
                                    </Grid>
                                    <hr className={styles.gwMLSidebarContactSectionHr} />
                                </React.Fragment>
                            )
                        })}
                    </AccordionCard>

                </React.Fragment>
            )}
        </Accordion>
    );
}

MLSidebarContactSection.propTypes = {
    metlifeGASection: PropTypes.shape({
        header: PropTypes.string,
        subsections: PropTypes.arrayOf(PropTypes.shape({
            subHeaderText: PropTypes.string,
            icon: PropTypes.string,
            text: PropTypes.array
        }))
    }).isRequired,
    arsUWSection: PropTypes.shape({
        header: PropTypes.string,
        subsections: PropTypes.arrayOf(PropTypes.shape({
            subHeaderText: PropTypes.string,
            icon: PropTypes.string,
            text: PropTypes.array
        }))
    }).isRequired,
    claimsSection: PropTypes.shape({
        header: PropTypes.string,
        subsections: PropTypes.arrayOf(PropTypes.shape({
            subHeaderText: PropTypes.string,
            icon: PropTypes.string,
            text: PropTypes.array
        }))
    }).isRequired,
    commiSection: PropTypes.shape({
        header: PropTypes.string,
        subsections: PropTypes.arrayOf(PropTypes.shape({
            subHeaderText: PropTypes.string,
            icon: PropTypes.string,
            text: PropTypes.array
        }))
    }),
    uwSection: PropTypes.shape({
        header: PropTypes.string,
        subsections: PropTypes.arrayOf(PropTypes.shape({
            subHeaderText: PropTypes.string,
            icon: PropTypes.string,
            text: PropTypes.array,
            subSubSections: PropTypes.arrayOf(PropTypes.shape({
                subSubHeaderText: PropTypes.string,
                lines: PropTypes.arrayOf(PropTypes.shape({
                    txt: PropTypes.string,
                    popup: PropTypes.shape({
                        popupheader: PropTypes.string,
                        popuptext: PropTypes.string
                    })
                }))
            }))
        }))
    })
};

MLSidebarContactSection.defaultProps = {
    id: undefined
};

export default MLSidebarContactSection;
